import en from "@/translations/en.json";
import pt from "@/translations/pt.json";
import i18next, { InitOptions } from "i18next";
import { initReactI18next } from "react-i18next";

export const i18NextConfig: InitOptions<unknown> = {
  resources: {
    pt,
    en,
  },
  lng: "pt",
  fallbackLng: "pt",
  interpolation: {
    escapeValue: false,
  },
};

i18next.use(initReactI18next).init(i18NextConfig);

export default i18next;
